import React from 'react';

const CaretLeftIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18.7999C14.8 18.7999 14.6 18.7999 14.5 18.5999L8.50002 12.5999C8.20002 12.2999 8.20002 11.7999 8.50002 11.4999L14.5 5.4999C14.8 5.1999 15.3 5.1999 15.6 5.4999C15.9 5.7999 15.9 6.2999 15.6 6.5999L10.1 12.0999L15.6 17.5999C15.9 17.8999 15.9 18.3999 15.6 18.6999C15.3 18.9999 15.3 18.8999 15.1 18.8999L15 18.7999Z" fill="currentColor"/>
        </svg>
    )
}

export default CaretLeftIcon;